export default {
	modal: {
		"& *:focus":{
			outline: "none",
		},

		'& div[role="document"]':{
			position: "relative",
		},


		"display": "flex",
		"align-items": "center",
		"justify-content": "center",
		"text-align": "center",
		"width": "100%",
		"top": "0",

		"& > div": {
			position: "relative"
		}
	},

	defaultBody:{
		textAlign: 'center',
		color: 'black',
		borderRadius: "20px",
		margin: "0 20px",
		maxWidth: "475px",
		padding: "32px"
	},

	image:{
		width: "70%",
		maxWidth: '175px',
		marginTop: '10px',
	},

	closeButton:{
		position: 'absolute',
		right: '10px',
		top: '-10px',
		height: 'auto',
		width: '35px',
		cursor: 'pointer',
		zIndex: 100
	}
}